import React from "react";
import { useField } from "formik";
import { FormattedNumberField } from "common/fields/FormattedNumberField";
import {
  CustomFieldSchemaFragment,
  MoneyPreviewFragment,
} from "__generated__/graphql";
import { getCustomFieldValueByType } from "customField/helpers/getCustomFieldNameValuePairs";

interface IFormikPreviewCurrencyFieldProps {
  name: string;
  labelledById: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder: string;
  schema?: CustomFieldSchemaFragment | null;
}
export const FormikPreviewCurrencyField: React.FC<
  IFormikPreviewCurrencyFieldProps
> = ({ name, placeholder, labelledById, schema, onKeyDown }) => {
  const [field, , helpers] = useField<string>({
    name,
  });

  const value =
    field.value && getCustomFieldValueByType(JSON.parse(field.value));

  const setValue = (newValue: string | null) => {
    helpers.setValue(
      JSON.stringify({
        __typename: "CustomFieldMoney",
        moneyValue: {
          ...(value as MoneyPreviewFragment),
          format: newValue || "",
        },
      }),
    );
  };
  return (
    <FormattedNumberField
      key={schema?.id}
      value={value ? parseFloat((value as MoneyPreviewFragment).format) : null}
      setValue={(newValue) => setValue(newValue?.toString() || null)}
      labelledById={labelledById}
      placeholder={placeholder}
      onKeyDown={onKeyDown}
    />
  );
};
